<!-- <div class="custom-alert-container" *ngIf="notRecognizedFields">
  <div class="custom-alert">
    <img src="assets/img/whoops-icon.png" alt="Whoops!" class="alert-icon">
    <h2>Whoops!</h2>
    <div class="recognized-fields">
      <p>Campos no reconocidos: </p>
      <ul [innerHTML]="notRecognizedFields">
      </ul>
      <p><strong>¡No te preocupes!</strong> Puedes modificarlos manualmente.</p>
       <p *ngIf="!canEditFields">Por el momento no podemos aceptar tu factura, intenta nuevamente con otra factura para participar.</p>
    </div>
    <button ion-button (click)="dismiss()">Continue</button>
  </div>
</div> -->

<div class="custom-alert-container">

  <div class="custom-alert">

    <button class="close-btn" (click)="dismiss()">
      ✕
    </button>

    <div class="success-icon">
      <div class="circle">
        ✓
      </div>
    </div>

    <h2>¡Tu factura se leyó bien!</h2>

    <p class="description">
      Solo falta que completes
      <strong>
        {{ fieldsCount }} campo{{ fieldsCount > 1 ? 's' : '' }}
      </strong>
      que no aparece{{ fieldsCount > 1 ? 'n' : '' }} claro{{ fieldsCount > 1 ? 's' : '' }} en la foto.
    </p>


    <!-- Fields -->
    <ion-list class="fields-container">
      <ion-item
        *ngFor="let field of notRecognizedFieldsList"
        lines="none"
        class="field-item"
      >
        <ion-icon
          slot="start"
          name="pencil-outline">
        </ion-icon>

        <div>{{ field }}</div>
      </ion-item>
    </ion-list>

    <div class="info-box">
      <p>
        Al continuar verás el formulario: escribe o selecciona este dato
        y luego envía tu factura. También puedes corregir cualquier otro
        dato si algo no coincide.
      </p>
    </div>

    <div class="warning-box">
      <p>
        ¿La foto no se ve bien?
        <span>
          También puedes volver a tomarla para que la lectura reconozca
          este dato por ti.
        </span>
      </p>
    </div>


    <!-- Buttons -->
    <button class="primary-btn" (click)="dismiss()">
      Completar dato
    </button>

    <button class="secondary-btn" (click)="goBack()">
      <ion-icon name="camera-outline"></ion-icon>
      Volver a tomar foto
    </button>


  </div>

</div>
